module.exports = __webpack_public_path__ + "static/media/Hanoded-Bumper-Sticker-Regular.9c94feb6.otf";